import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStreamEnvironment, ErmCapabilityApiClientService } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-launch-error',
  templateUrl: './launch-error.component.html',
  styleUrls: ['./launch-error.component.scss']
})
export class LaunchErrorComponent implements OnInit {

  errorCode?: string;
  env?: AppStreamEnvironment;
  isWorking?: boolean;

  constructor(
    private route: ActivatedRoute,
    private ermCapabilityApiClient: ErmCapabilityApiClientService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      this.isWorking = true;

      // Get route parameters
      const params = this.route.snapshot.params;
      const envId = params['envId'];
      this.errorCode = params['errorCode'];

      // Get environment
      const getAppStreamEnvironmentResponse = await this.ermCapabilityApiClient.getAppStreamEnvironment(envId);
      this.env = getAppStreamEnvironmentResponse.body?.appStreamEnvironment;

    } finally {
      this.isWorking = false;
    }
  }
}
